import { useEffect, useRef } from "react";

const useApiQueueLoading = (overlayId, onActiveChange) => {
  const timerRef = useRef(null);
  const activeRef = useRef(false);
  const onActiveChangeRef = useRef(onActiveChange);
  onActiveChangeRef.current = onActiveChange;

  const activate = () => {
    activeRef.current = true;
    if (onActiveChangeRef.current) onActiveChangeRef.current(true);
    const overlay = document.getElementById(overlayId);
    if (overlay) overlay.style.display = "flex";
  };

  window.__activateQueueLoader = activate;

  useEffect(() => {
    const handler = (e) => {
      if (!activeRef.current) return;
      const overlay = document.getElementById(overlayId);
      if (!overlay) return;
      if (e.detail.size > 0) {
        clearTimeout(timerRef.current);
        overlay.style.display = "flex";
      } else {
        timerRef.current = setTimeout(() => {
          overlay.style.display = "none";
          activeRef.current = false;
          if (onActiveChangeRef.current) onActiveChangeRef.current(false);
        }, 5500);
      }
    };
    window.addEventListener("apiQueueChange", handler);
    return () => {
      window.removeEventListener("apiQueueChange", handler);
      clearTimeout(timerRef.current);
    };
  }, [overlayId]);

  return { activate };
};

export default useApiQueueLoading;
